import { useEffect } from "react";

const SITE = "House of Projects";

function setMeta(selector, attr, value, create) {
  let el = document.head.querySelector(selector);
  if (!el && create) {
    el = document.createElement("meta");
    create(el);
    document.head.appendChild(el);
  }
  if (el) el.setAttribute(attr, value);
}

/** Lightweight per-page metadata (no extra dependency). */
export default function Seo({ title, description, path = "/" }) {
  useEffect(() => {
    const full = title ? `${title} | ${SITE}` : `${SITE} | Business Consultancy`;
    document.title = full;
    setMeta('meta[name="description"]', "content", description, (e) => e.setAttribute("name", "description"));
    setMeta('meta[property="og:title"]', "content", full, (e) => e.setAttribute("property", "og:title"));
    setMeta('meta[property="og:description"]', "content", description, (e) => e.setAttribute("property", "og:description"));
    setMeta('meta[property="og:url"]', "content", window.location.origin + path, (e) => e.setAttribute("property", "og:url"));
  }, [title, description, path]);
  return null;
}
